import axios from 'axios';

// TODO: configure the API...

class APIError extends Error {
    constructor(error = {}) {
        super(error.message, error.code);
        this.code = error.code;
    }

    toString() {
        return `(${this.code}) ${this.message}`;
    }
}

const client = axios.create({
    baseURL: process.env.REACT_APP_BASE_API,
    withCredentials: true,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json',
    },
    transformResponse: ({ success, error, data }) => {
        if (!success) {
            if (error) {
                throw new APIError(error);
            }
            if (data.error) {
                throw new APIError(data.error);
            }
        }
        return data;
    },
    validateStatus: (status) => status >= 200 && status <= 500,
});

client.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    (error) => {
        if (error.code === 401) {
            // RequireLoginAction();
        }
        return Promise.reject(error);
    },
);

export default client;
